import script from "./messageCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./messageCard.vue?vue&type=script&setup=true&lang=ts"

import "./messageCard.vue?vue&type=style&index=0&id=762a7c79&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762a7c79"]])

export default __exports__